import axios from "axios";
import config from "../config/env/index";
type BilanResponseHeader = { "content-disposition": string };

const getBilan = async (code: string, recipient_name: string, without_identity: boolean) => {
  try {
    const params = {
      recipient_name,
      without_identity,
    };
    const response = await axios({
      url: `${config.api_url}api/v3/public/reports/${code}/download`,
      method: "GET",
      params,
      responseType: "blob",
    });
    const headers = response.headers;
    let data = response.data;
    let result = undefined;

    if (headers["content-type"] === "application/json; charset=utf-8") {
      const responseData = await data.text();
      data = JSON.parse(responseData);
      result = { data: data, json: true, name: "" };
    } else {
      result = {
        data: data,
        name: getHeaderName(headers as BilanResponseHeader),
        json: false,
      };
    }
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

const getExpiredBilan = async (code: string, data: object) => {
  try {
    const response = await axios({
      url: `${config.api_url}api/v3/public/reports/${code}/validate_extend_delay`,
      method: "POST",
      data,
      responseType: "blob",
    });
    const result = {
      data: response.data,
      name: getHeaderName(response.headers as BilanResponseHeader),
    };

    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

const getHeaderName = (headers: BilanResponseHeader) => {
  return headers["content-disposition"].split('"')[1];
};

export default {
  getBilan,
  getExpiredBilan,
};
